import React from "react";
import MobileRecording from "./mobileRecording";
import MobileRecordingHeader from "./mobileRecordingHeader";
import MobileContinueButton from "../button/mobileContinueButton";
import MobileCancelButton from "../button/mobileCancelButton";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";

class MobileRecordingNumberList extends MobileRecording {
    constructor(props) {
        super();
    }

    render = () => {
        const {
            currentFlowChart,
            currentRecordingFlowChart,
            recordData
        } = this.props;

        let data = [];
        let columns = [];

        const ReactTableFixedColumns = withFixedColumns(ReactTable);

        const continueButtonDisabled = this.isContinueButtonDisabled(
            currentRecordingFlowChart,
            recordData
        );
        const selectionDisabled = this.isSelectionDisabled(
            currentRecordingFlowChart,
            recordData
        );

        // const tableStyle = {
        //   border: "none",
        //   boxShadow: "none",
        //   padding: "0px 0px"
        // };

        // const columnSettings = {
        //   ...ReactTableDefaults.column,
        //   minWidth: 20
        // };

        const tightStyle = () => {
            return {
                style: {
                    // fontSize: "x-small",
                    padding: "2px 2px",
                    margin: "0"
                    //          height: "30px"
                }
            };
        };

        columns = [
            {
                // width: 300,
                Header: (
                    <MobileRecordingHeader
                        title={currentFlowChart.title.text}
                        subTitle={
                            currentRecordingFlowChart.title.text +
                            ": " +
                            recordData.fields[
                                `${currentRecordingFlowChart.tableField}Display`
                                ]
                        }
                    />
                ),
                Cell: ({original}) => (
                    // <div
                    //   value={original.text}
                    //   disabled={this.isSelectionDisabled(
                    //     selectionDisabled,
                    //     original.id,
                    //     original.text
                    //   )}
                    //   style={{
                    //     textAlign: "center"
                    //   }}
                    // >
                    //   {original.text}
                    // </div>
                    <button
                        className="btn btn-secondary btn-sm btn-block"
                        onClick={() => {
                            this.onChange(original.text);
                        }}
                        value={original.text}
                        disabled={selectionDisabled && !original.textAlwaysEnabled}
                    >
                        {original.text}
                    </button>
                ),
                Footer: () => (
                    <React.Fragment>
                        <div
                            className="btn-toolbar justify-content-between"
                            role="toolbar"
                            aria-label="Toolbar with button groups"
                        >
                            <MobileContinueButton
                                onClick={() => {
                                    this.onFieldContinue();
                                }}
                                disabled={continueButtonDisabled}
                                title={{text: "Weiter"}}
                            />
                            <MobileCancelButton
                                onClick={() => {
                                    this.onFieldCancel();
                                }}
                                title={{text: "Abbrechen"}}
                            />
                        </div>
                    </React.Fragment>
                )
            }
        ];
        for (let counter = 0; counter <= 9; counter++) {
            data.push({id: counter, text: `${counter}`});
        }
        data.push({id: "backspace", text: "backspace", textAlwaysEnabled: true});
        data.push({id: "clear", text: "clear", textAlwaysEnabled: true});

        return (
            <React.Fragment>
                <ReactTableFixedColumns
                    columns={columns}
                    data={data}
                    defaultPageSize={data.length}
                    showPagination={false}
                    // getTrProps={onMenuClick}
                    // style={this.tableStyle}
                    // column={columnSettings}
                    getTheadThProps={tightStyle}
                    getTdProps={tightStyle}
                    //style={{ height: window.innerHeight }}
                />
            </React.Fragment>
        );
    }
}

export default MobileRecordingNumberList;
